export const Footer = () => {
  return (
    <footer style={{ padding: "2rem" }}>
      <img
        src='/logo/sponsors.svg'
        alt='Sponsors'
        style={{
          width: "100%",
          height: "auto",
          objectFit: "contain",
        }}
      />
    </footer>
  );
};
